import { MessageEnvelope } from '@zonofi/common/schema/message';
import { ConversationData } from '@zonofi/zono-money-store';

export interface PriceUpdatedProduct {
  productId: number;
  pvId: number;
  price: number;
  ptr?: number;
}

export type ProductPriceUpdateMap = Record<string, PriceUpdatedProduct>;

export interface ValidationResult {
  error?: string;
  success: boolean;
}

export type ValidationRule = (
  value: string,
  error?: string
) => ValidationResult;

export enum DateRangeKeys {
  Today = 'Today',
  Yesterday = 'Yesterday',
  ThisWeek = 'This Week',
  LastWeek = 'Last Week',
  ThisMonth = 'This Month',
  Last3Months = 'Last 3 Months',
}

export interface ChipDataItem {
  id: string;
  value: string;
  selected: boolean;
  type?: 'date' | 'text';
}

export interface ChipFilterSection {
  items: ChipDataItem[];
  onItemPress: (item: ChipDataItem) => void;
}

export interface FunnelGroupInfo {
  icon: string;
  group_type: 'automatic' | 'manual';
  color: string;
}

export interface ModalContentItemData {
  icon: JSX.Element;
  title: string;
  description?: string;
  onPress: () => void;
  isSelected?: boolean;
}

export type ConvervationModalVariant =
  | 'none'
  | 'assign'
  | 'update-status'
  | 'tags'
  | 'more'
  | 'lifecycle';

export interface ConversationModalState {
  variant: ConvervationModalVariant;
  open: boolean;
  conversation: ConversationData;
}

export interface DisplayNotificationObject
  extends ConversationAssignmentNotificationData {
  title: string;
  body: string;
  type: 'conversation_assignment';
}

export interface ConversationAssignmentNotificationData {
  type: string;
  customerId: string;
  notificationType: string;
  conversationId: string;
  customerName: string;
}

export interface FilterProps {
  chipFilters?: React.ReactNode;
  selectCheckbox?: React.ReactNode;
}

export interface PaginationMeta {
  startRecord: number;
  endRecord: number;
  totalCount: number;
}

export enum TripInfoTaskType {
  NOT_CLOCKED_IN = 'NOT_CLOCKED_IN',
  ALREADY_CHECKED_IN = 'ALREADY_CHECKED_IN',
  NOT_CHECKED_OUT = 'NOT_CHECKED_OUT',
  NOT_CHECKED_IN = 'NOT_CHECKED_IN',
  NOT_SYNC = 'NOT_SYNC',
  NOT_SYNCED_CLOCK_OUT = 'NOT_SYNCED_CLOCK_OUT',
  NOT_SYNCED_LOG_OUT = 'NOT_SYNCED_LOG_OUT',
}

export enum TripCheckInOutType {
  // CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT',
  CHECK_IN_SUCCESS = 'CHECK_IN_SUCCESS',
  CHECK_OUT_SUCCESS = 'CHECK_OUT_SUCCESS',
}

export interface InAppModalGroupRef {
  openClockInModal: () => void;
  openTripInfoModal: (type: TripInfoTaskType) => void;
  openCheckOutModal: (type: TripCheckInOutType) => void;
}

export interface RedirectionModalRef {
  openRedirectionModal: () => void;
}

export interface AddCustomerModalGroupRef {
  openSuccessModal: () => void;
  openFilterModal: () => void;
  opneLocationMoadal: () => void;
}

export enum CustomerListActionType {
  NO_TYPE = 'null',
  SEND_LEDGER = 'send-ledger',
  CREATE_ORDER = 'create-order',
  COLLECT_PAYMENT = 'collect-payment',
  UPLOAD_INVOICE = 'upload-invoice',
  UPLOAD_DISPATCH_NOTE = 'upload-dispatch-note',
}

export enum SendSelectedType {
  DISPACH_NOTE = 'dispatchNote',
  PAYMENT = 'payment',
  ORDER = 'order',
}

export type MediaActiveModal =
  | 'NONE'
  | 'MEDIA_ACTIONS'
  | 'MEDIA_UPLOAD'
  | 'IMAGE_PREVIEW';

export interface QueryGroupRange {
  groupId: string;
  conversationThreadId: string;
  startTimeToken?: number;
  endTimeToken?: number;
  queryType: string;
  backgroundColor: string;
}

export interface DayBucketMeta {
  type: 'day';
  key: string;
  dayKey: string;
}

export interface QueryBucketMeta {
  type: 'query';
  key: string;
  groupId: string;
  lowerBound: number;
  upperBound: number;
  queryType: string;
  backgroundColor: string;
}

export type MessageListBucketMeta = DayBucketMeta | QueryBucketMeta;

export type MessageListMessage = MessageEnvelope & {
  messageListBucket: MessageListBucketMeta;
};

export interface DateGroupSeparator {
  type: 'date';
  dayKey: string;
}

export interface QueryGroupSeparator {
  type: 'query';
  boundary: 'start' | 'end';
  groupId: string;
  lowerBound: number;
  upperBound: number;
  queryType: string;
  backgroundColor: string;
}

export type MessageListSeparator = DateGroupSeparator | QueryGroupSeparator;

export type MessageListItem = MessageListMessage | MessageListSeparator;

export interface DrawerItems {
  id?: string;
  label: string;
  fullMatch?: boolean;
  icon?: string;
  route?: string;
  isExpanded?: boolean;
  actionType?: string;
  sublabel?: string;
  children?: Omit<DrawerItems, 'children' | 'isExpanded'>[];
  show?: boolean;
}

export type RelativeTimeRange =
  | 'LAST_24_HOURS'
  | 'LAST_3_DAYS'
  | 'LAST_7_DAYS'
  | 'LAST_15_DAYS'
  | 'LAST_30_DAYS'
  | 'LAST_60_DAYS';
